import React from "react";
import ConfigContainer from "./ConfigContainer/ConfigContainer";
import ContractDetails from "./ContractDetails/ContractDetails";

const PaymentMainDashboard = () => {
  return (
    <div
      style={{ height: "calc(100% - 32px)" }}
      className="display_flex_column"
    >
      <ConfigContainer />
      <ContractDetails />
    </div>
  );
};

export default PaymentMainDashboard;
